var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 3.83333V13.1667H3.33333V3.83333H12.6667ZM12.6667 2.5H3.33333C2.6 2.5 2 3.1 2 3.83333V13.1667C2 13.9 2.6 14.5 3.33333 14.5H12.6667C13.4 14.5 14 13.9 14 13.1667V3.83333C14 3.1 13.4 2.5 12.6667 2.5Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 11.8333H4.66667V10.5H9.33333V11.8333ZM11.3333 9.16667H4.66667V7.83333H11.3333V9.16667ZM11.3333 6.5H4.66667V5.16667H11.3333V6.5Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFilterIcon);
export default __webpack_public_path__ + "static/media/file_filter_icon.22eb4b09619dde857e06f3d4507298d7.svg";
export { ForwardRef as ReactComponent };